import { HTTP } from '../../http-common'

export default {
  state: {
    loadedDevices2: []
  },
  getters: {
    loadedDevices2 (state) {
      return state.loadedDevices2
    }
  },
  mutations: {
    setLoadedDevices2 (state, payload) {
      state.loadedDevices2 = payload
    },
    createDevices2 (state, payload) {
      state.loadedDevices2.push(payload)
    },
    updateDevices2 (state, payload) {
      state.loadedDevices2 = state.loadedDevices2.map(devices => devices.id === payload.id ? payload : devices)
    },
    removeDevices2 (state, id) {
      state.loadedDevices2 = state.loadedDevices2.filter(devices => {
        return devices.id !== id
      })
    },
    clearLoadedDevices (state) {
      state.loadedDevices2 = []
    }
  },
  actions: {
    loadDevices2 ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedDevices2', [])

      return new Promise((resolve, reject) => {
        HTTP.get('device.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedDevices2', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createDevice2 ({ commit, getters }, payload) {
      console.log('createDevice2')
      commit('clearError')
      commit('setLoading', true)
      const newDevice = {
        description: payload.description,
        device_manufacturer: {
          id: payload.device_manufacturer.id
        },
        device_type: {
          id: payload.device_type.id
        },
        device_model: {
          id: payload.device_model.id
        },
        barn: {
          id: payload.barn.id
        }
      }
      console.log('newDevice', newDevice)
      return new Promise((resolve, reject) => {
        HTTP.post('device.json/', newDevice)
          .then(result => {
            console.log(result)
            commit('createDevices2', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log('estou no erro aqui')
            console.log(err.data)
            console.log(err.statusText)
            console.log(err.status)
            console.log('meu erro aqui', err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateDevice2 ({ commit, getters }, payload) {
      console.log('updateDevice2')
      commit('clearError')
      commit('setLoading', true)
      const device = {
        description: payload.description,
        device_manufacturer: {
          id: payload.device_manufacturer.id
        },
        device_type: {
          id: payload.device_type.id
        },
        device_model: {
          id: payload.device_model.id
        },
        barn: {
          id: payload.barn.id
        }
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`device.json/${payload.id}/`, device)
          .then(result => {
            console.log(result)
            commit('updateDevices2', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeDevices2 ({ commit }, payload) {
      console.log('removeDevices2')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`device.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeDevices2', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedDevices ({ commit }) {
      commit('clearLoadedDevices')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/device2/index.js